import { jsx as i } from "react/jsx-runtime";
import { forwardRef as l, useCallback as c } from "react";
import o from "./styles.module.less.js";
const f = l(
  (r, s) => {
    var n;
    const { value: m, disabled: a, onChange: t, error: p } = r, u = c((e) => {
      e.preventDefault(), e.stopPropagation(), a || t(e.target.value);
    }, [a, t]);
    return /* @__PURE__ */ i(
      "input",
      {
        ref: s,
        ...r.props,
        className: `${o.numericInput} ${(n = r.props) == null ? void 0 : n.className} ${p ? o.error : ""}`,
        type: "number",
        value: m,
        onChange: u
      }
    );
  }
);
f.displayName = "NumericInput";
export {
  f as NumericInput
};
